const mountCredentialsApp = () => {
  import(
    /* webpackChunkName: "credentials-app" */ '../credentials/bootstrap'
  )
    .then(({default: bootstrap}) => {
      bootstrap();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load credentials chunk', error);
    });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountCredentialsApp);
} else {
  mountCredentialsApp();
}
